import { CNAME } from 'src/constants';

export const redirectToMain = () => {
  window.location.href = CNAME;
};
